// extracted by mini-css-extract-plugin
export var container = "_d2-1";
export var cornerButtonContainer = "_d2-6";
export var disabled = "_d2-2";
export var dragActive = "_d2-3";
export var fileContainer = "_d2-5";
export var hiddenInput = "_d2-4";
export var widthContainer = "_d2-0";